import styled from "styled-components";

export const DescriptionText = styled.p`
	color: gray;
	margin: 0px;
	font-size: ${props => props.fontSize}px;
`;

export const DifficultyContainer = styled.div`
	display: flex;
	height: 100%;
	width: auto;
`;
